import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const messages = [];

export const MessageContext = createContext(messages);
export const DispatchMessageContext = createContext(null);
export const MessageProvider = ({ children, dispatch, value }) => (
  <DispatchMessageContext.Provider value={dispatch}>
    <MessageContext.Provider value={value}>
      {children}
    </MessageContext.Provider>
  </DispatchMessageContext.Provider>
);

MessageProvider.propTypes = propTypes;
